import React, { Component } from 'react'
// import styled from 'styled-components'
import { Header, PageWrapper } from '../components'
import axios from 'axios'
import { API_URL } from '../constants'
import Cookies from 'js-cookie'
import { get } from 'lodash'
// import qs from 'qs'

class Blogs extends Component {
  state = {
    blogData: []
  }

  async componentDidMount() {
    /*   const blogQuery = {
      filter: {
        limit: 1
      }
    } */
    try {
      const { data } = await axios.get(`${API_URL}/Blogs?access_token=${Cookies.get('access_token')}`)
      this.setState({ blogData: data })
    } catch (error) {
      this.setState({ isLoading: false })
      console.log('ERROR', error)
    }
  }
  render() {
    const {
      match: { params }
    } = this.props

    return (
      <React.Fragment>
        <Header
          title={`${params.key === 'warning' ? 'Warning' : 'GCNow Stories'}`}
          icon="arrowBack"
          onClickBack={() =>
            params.key === 'warning' ? this.props.history.goBack() : this.props.history.replace('/home')
          }
          color="#fff"
        />
        <PageWrapper viewPadding="84px 16px 0">
          {params.key !== 'warning' ? (
            <iframe
              width="100%"
              height="600"
              frameBorder="0"
              title="gc"
              src={`https://www.greenchoicenow.com/gcnow/${params.key}`}
            />
          ) : params.key === 'warning' ? (
            <iframe
              width="100%"
              height="600"
              frameBorder="0"
              title="usatoday"
              src={get(this.props, 'location.state.link', '')}
            />
          ) : (
            <iframe width="100%" height="600" frameBorder="0" title="gc" src={'https://www.greenchoicenow.com/gcnow'} />
          )}
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default Blogs



// WEBPACK FOOTER //
// ./src/pages/Blogs.js